module.exports = __webpack_public_path__ + "static/media/custom.9e9fc22f.svg";